enum Action {
  SET_FILTERS = 'setFilters',
  SET_ABSENCE_REASONS_IDS = 'setAbsenceReasonsIds',
  SET_LOCATIONS_POSITION_IDS = 'setLocationsPositionIds',
}

export default Action;
